/* Who takes a client who booked a technician.
 *
 * 'book' is the board's long-standing answer: the booked technician. 'turn'
 * gives the client to whoever is next in turn order. Only an exact 'turn' turns
 * it on — a row this build does not understand, or a typo in the raw editor,
 * is the book, the way it was before the setting existed.
 *
 * This file imports nothing, for the same reason as js/rules/conflict.js.
 */

export function followsBook(value) {
  return value !== 'turn';
}
